import { useState } from "react";
import get from "lodash/get";
import map from "lodash/map";
import intersection from "lodash/intersection";
import isEmpty from "lodash/isEmpty";
import parseInt from "lodash/parseInt";
import upperFirst from "lodash/upperFirst";

import useCart from "grandus-lib/hooks/useCart";
import { InputNumber, Button, message } from "antd";
import EnhancedEcommerce from "utils/ecommerce";
import TagManager from "grandus-lib/utils/gtag";
// import useExpress, { color, Icon } from "utils/useExpress";
import useWebInstance from "grandus-lib/hooks/useWebInstance";

import styles from "./AddToCartButton.module.scss";
import { useTranslation } from 'next-i18next';

const AddToCartButton = ({ product, stores, options = {} }) => {
  const { id: productId, isOrderable } = product;
  // const { express, intersectStores, isActive, deactivate } = useExpress();

  const { t } = useTranslation();

  const productStores = map(
    get(stores, "[0].storeData", []),
    (option) => option?.storeUrlName
  );
  // const isAvailableForExpress = intersection(
  //   productStores,
  //   express?.activeStores
  // );

  const { itemAdd } = useCart();
  const key = `message-add-to-cart-${productId}`;

  const singleStore = get(stores, "[0]");

  const [count, setCount] = useState(1);
  const [store, setStore] = useState(singleStore?.id);
  const [loading, setLoading] = useState(false);
  const { webInstance } = useWebInstance();

  if (!stores.length || !isOrderable) return null;

  async function handleAddToCart(e) {
    setLoading(true);
    message.loading({
      content: upperFirst(t('common:adding item to cart')),
      duration: 0,
      key,
    });
    itemAdd(count, store, productId, () => {
      message.success({
        content: upperFirst(t('common:item was successfuly added to cart')),
        duration: 4,
        key,
      });
      // intersectStores(productStores);
      TagManager.push(
        EnhancedEcommerce.cartAdd(get(options, "eecProduct"), count)
      );
      setLoading(false);
    });
    return false;
  }

  const maxCount =
    parseInt(get(webInstance, "globalSettings.cart_max_pieces_count", 0)) > 0
      ? parseInt(get(webInstance, "globalSettings.cart_max_pieces_count", 0))
      : singleStore.count > 0
      ? singleStore.count
      : 2;

  return (
    <>
      {/* {isActive() ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            backgroundColor: color,
            padding: "15px",
            borderRadius: "15px",
            maxWidth: "330px",
            marginBottom: "15px",
          }}
        >
          {!isEmpty(isAvailableForExpress) ? (
            <>
              <Icon width={"32px"} />
              <span style={{ marginLeft: "15px" }}>
                {upperFirst(t("common:express delivery is available"))};
              </span>
            </>
          ) : (
            <span>
              {upperFirst(t("common:you have express delivery activated"))}.
              {upperFirst(
                t(
                  "product:it is not possible to deliver product within selected area"
                )
              )}{" "}
              <b>{express.name}</b>.{" "}
              <u style={{ cursor: "pointer" }} onClick={() => deactivate()}>
                {upperFirst(t("common:cancel"))}?
              </u>
            </span>
          )}
        </div>
      ) : (
        ""
      )} */}
      <div className={styles.wrapper}>
        {singleStore.count !== 1 ? (
          <InputNumber
            className={styles.input}
            min={1}
            max={maxCount}
            defaultValue={1}
            placeholder={1}
            onChange={(value) => setCount(value)}
          />
        ) : (
          ""
        )}
        <Button
          id={"primaryDetailButton"}
          className={styles.button}
          type="primary"
          loading={loading}
          onClick={(e) => handleAddToCart(e)}
        >
          {upperFirst(t("common:add to cart"))}
        </Button>
      </div>
    </>
  );
};

export default AddToCartButton;
